import {get, isEmpty} from 'lodash'
import {
  getLipSyncAudioTrackFromSprite,
  getLipSyncPlaybackSettingsFromSprite,
  isImageHolderItem
} from 'powtoon-document'
import {
  Track,
  TextTrack,
  TrackSprite,
  TextTrackSprite,
  Slide,
  Id,
  TrackItem, BasePlaybackSettings, VoiceOverAudioItem
} from 'powtoon-versioning/src/currentSchema'

export function getFirstTrackSprite(tracks: Slide['tracks']): TrackSprite | TextTrackSprite {
  const track = get(tracks, [0], {}) as Track
  return getFirstSprite(track)
}
export function getFirstSprite<T extends Track | TextTrack>(track: T):
  T extends Track ? TrackSprite  : TextTrackSprite {
  const sprite = track?.sprites?.[0] || {}
  return sprite as T extends Track ? TrackSprite : TextTrackSprite
}

export function createListOfSpriteIdsFromTracks(tracks: (Track | TextTrack)[]): Id[] {
  return tracks.map(track => getFirstSprite(track).id)
}

export function createListOfTrackIds(tracks: (Track | TextTrack)[]): Id[] {
  return tracks.map(track => track.id)
}

export function getSpriteOrSpriteContent<T extends Track | TextTrack>(track: T): TrackSprite | TextTrackSprite {
  const sprite = getFirstSprite(track)
  if (isImageHolderItem(sprite) && !isEmpty(sprite.content)) {
    return sprite.content as TrackSprite
  }
  return sprite
}

export function getLipSyncPlaybackSettingsFromTrack(track: TrackItem): undefined | BasePlaybackSettings {
  if (!track) {
    return undefined
  }
  const trackContent = getSpriteOrSpriteContent(track)
  return trackContent ? getLipSyncPlaybackSettingsFromSprite(trackContent) : undefined
}

export function getLipSyncAudioTrackFromTrack(track: TrackItem): null | VoiceOverAudioItem {
  if (!track) {
    return null
  }
  const trackContent = getSpriteOrSpriteContent(track)
  return trackContent ? getLipSyncAudioTrackFromSprite(trackContent) : null
}

export const isLipSyncAudioSpriteActiveInTrack = (track: TrackItem): boolean => {
  return !!getLipSyncAudioTrackFromTrack(track)
}

export const isImageHolderTrack = (track: TrackItem): boolean => {
  if (!track) {
    return false
  }
  const sprite = getFirstSprite(track)
  return isImageHolderItem(sprite)
}